import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Button } from './button';
import { Printer, Download } from 'lucide-react';

const QRCodeDisplay = ({ value, name, showPrint = true, size = 128 }) => {
  const qrRef = useRef(null);

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const qrElement = qrRef.current;
    
    if (printWindow && qrElement) {
      const svg = qrElement.querySelector('svg');
      if (svg) {
        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Print QR Code - ${value}</title>
              <style>
                body {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  min-height: 100vh;
                  margin: 0;
                  font-family: Arial, sans-serif;
                }
                .qr-container {
                  text-align: center;
                  padding: 20px;
                  border: 1px dashed #ccc;
                  margin: 10px;
                }
                .item-name {
                  font-size: 14px;
                  font-weight: bold;
                  margin-bottom: 10px;
                  color: #333;
                }
                .sku-value {
                  font-size: 12px;
                  color: #666;
                  margin-top: 8px;
                  font-family: monospace;
                }
                @media print {
                  .qr-container {
                    border: none;
                  }
                }
              </style>
            </head>
            <body>
              <div class="qr-container">
                ${name ? `<div class="item-name">${name}</div>` : ''}
                ${svg.outerHTML}
                <div class="sku-value">${value}</div>
              </div>
              <script>
                window.onload = function() {
                  window.print();
                  window.onafterprint = function() { window.close(); }
                }
              </script>
            </body>
          </html>
        `);
        printWindow.document.close();
      }
    }
  };

  const handleDownload = () => {
    const qrElement = qrRef.current;
    if (qrElement) {
      const svg = qrElement.querySelector('svg');
      if (svg) {
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        
        img.onload = function() {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.fillStyle = 'white';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0);
          
          const pngUrl = canvas.toDataURL('image/png');
          const downloadLink = document.createElement('a');
          downloadLink.href = pngUrl;
          downloadLink.download = `qrcode-${value}.png`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        };
        
        img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
      }
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div ref={qrRef} className="bg-white p-3 rounded border border-gray-200">
        <QRCodeSVG 
          value={value} 
          size={size}
          level="M"
          includeMargin={true}
          bgColor="#ffffff"
          fgColor="#000000"
        />
      </div>
      <p className="text-xs text-gray-500 mt-2 font-mono">{value}</p>
      {showPrint && (
        <div className="flex gap-2 mt-2">
          <Button 
            variant="outline" 
            size="sm" 
            onClick={handlePrint}
            className="text-xs"
          >
            <Printer className="w-3 h-3 mr-1" />
            Print
          </Button>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={handleDownload}
            className="text-xs"
          >
            <Download className="w-3 h-3 mr-1" />
            Save
          </Button>
        </div>
      )}
    </div>
  );
};

export default QRCodeDisplay;
